import { render, staticRenderFns } from "./ModalDetalhesPedido.vue?vue&type=template&id=51bf3bf2&scoped=true"
import script from "./ModalDetalhesPedido.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesPedido.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesPedido.vue?vue&type=style&index=0&id=51bf3bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf3bf2",
  null
  
)

export default component.exports